'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props, traits) {
  var styles = props.styles;
  var colors = traits.colors;


  return {
    root: _extends({
      cursor: 'pointer',
      borderTop: '1px solid ' + colors.shade,
      ':hover': {
        backgroundColor: colors.paleGrey
      }
    }, styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-search-result/styles.js
// module id = 897
// module chunks = 0